























































import Vue, { PropType } from 'vue';
import { mapGetters, mapState } from 'vuex';
import { IAssetManagerItem } from '@/composers/asset-manager';
import { CurrencyCode } from '@/services/finance';
import FullscreenButton from '@/components/FullscreenButton.vue';
import LoaderInline from '@/components/LoaderInline.vue';
import { uploadFormats } from '../../common';
import { Product } from '../../types';

export default Vue.extend({
  props: {
    currencies: Array as PropType<CurrencyCode[]>,
    readOnly: Boolean,
    value: {
      type: Object as PropType<Product>,
      default: {},
    },
  },
  computed: {
    ...mapGetters('asset', { loadedAssets: 'list' }),
    ...mapState('asset', { allAssets: 'assets' }),
    isProcessing(): boolean {
      return !!((this as any).allAssets as IAssetManagerItem[]).find(asset => {
        const isProductAsset = asset.data.type_id === this.value.id;
        const isProcessing = asset.uploadId || asset.removing;
        return isProductAsset && !!isProcessing;
      });
    },
    imageAsset() {
      // if record linked to product, use products first image
      const hasProduct = this.value.product;
      if (hasProduct) {
        const firstAsset = hasProduct
        && hasProduct.assets
        && hasProduct.assets[0];

        return firstAsset
          ? {
              data: {
                src: firstAsset.src,
              },
            }
          : '';
      }

      // find first image in list of assets
      return ((this as any).loadedAssets as IAssetManagerItem[]).find(asset => {
        const { src, type_id } = asset.data;
        const isProductAsset = type_id === this.value.id;
        const fileExt = src.split('.').pop();
        return isProductAsset && fileExt && (uploadFormats as any)[fileExt];
      });
    },
  },
  components: {
    FullscreenButton,
    LoaderInline,
  },
});
